import React, { useContext, useEffect, useState } from 'react';
import { Flex, Form, Input, InputNumber, Select } from 'antd';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
const { TextArea } = Input;
import OptimizeRoiDisplay from '@totem/components/ticketing/details/optimize/optimizeRoiDisplay';
import {
  Optimize,
  OptimizeOptions,
} from '@totem/components/ticketing/optimizeTypes';
import { defaultOptimize } from '@totem/components/ticketing/utilities';
import { isNotNull } from '@totem/utilities/common';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  optimize: Optimize;
  onChange: (optimize: Optimize) => void;
};
const OptimizeForm = ({ optimize, onChange }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [optimizeOptions, setOptimizeOptions] = useState<OptimizeOptions>({
    categories: [],
    savingsTerms: [],
    scopeOfReturn: [],
    levelOfEffort: [],
    periods: [],
    savingsTypes: [],
  });
  const [optimizeData, setOptimizeData] = useState<Optimize>(
    isNotNull(optimize) ? optimize : { ...defaultOptimize },
  );
  useEffect(() => {
    fetch(`${TICKETS_ENDPOINT}/optimize/options`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: OptimizeOptions) => {
        setOptimizeOptions(result);
      });
  }, [getApiToken]);

  useEffect(() => {
    onChange(optimizeData);
  }, [optimizeData]);

  return (
    <div>
      <Form.Item label="Required Investment">
        <InputNumber
          min={0}
          style={{ width: '150px' }}
          value={optimizeData.requiredInvestment}
          onChange={(value) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              requiredInvestment: value,
            }))
          }
        />
      </Form.Item>
      <Form.Item label="Savings Type">
        <Select
          style={{ width: '220px' }}
          value={isNotNull(optimizeData) ? optimizeData.savingsType : ''}
          options={optimizeOptions.savingsTypes}
          onChange={(newValue) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              savingsType: newValue,
            }))
          }
        />
      </Form.Item>
      <Form.Item label="Savings Potential">
        <Flex justify={'flex-start'} align={'center'}>
          <Form.Item label="Amount">
            <InputNumber
              min={0}
              style={{ width: '150px' }}
              value={optimizeData.savingsPotential}
              onChange={(value) =>
                setOptimizeData((prevState) => ({
                  ...prevState,
                  savingsPotential: value,
                }))
              }
            />
          </Form.Item>
          <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>per</span>
          <Form.Item label="Savings Term Period">
            <Select
              style={{ width: '150px' }}
              value={
                isNotNull(optimizeData) ? optimizeData.savingsTermPeriod : ''
              }
              options={optimizeOptions.savingsTerms}
              onChange={(newValue) =>
                setOptimizeData((prevState) => ({
                  ...prevState,
                  savingsTermPeriod: newValue,
                }))
              }
            />
          </Form.Item>
          <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>for</span>
          <Form.Item label="Savings Term">
            <InputNumber
              min={0}
              style={{ width: '80px' }}
              value={optimizeData.savingsTerm}
              onChange={(value) =>
                setOptimizeData((prevState) => ({
                  ...prevState,
                  savingsTerm: value,
                }))
              }
            />
          </Form.Item>
          <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>
            {isNotNull(optimizeData)
              ? optimizeData.savingsTermPeriod !== ''
                ? `${optimizeData.savingsTermPeriod}`
                : optimizeData.savingsTermPeriod
              : ''}
            (s)
          </span>
        </Flex>
      </Form.Item>
      <Form.Item label="Return on Investment">
        <OptimizeRoiDisplay optimize={optimizeData} />
      </Form.Item>
      <Form.Item label="Level of Effort">
        <Select
          style={{ width: '150px' }}
          value={isNotNull(optimizeData) ? optimizeData.levelOfEffort : ''}
          options={optimizeOptions.levelOfEffort}
          onChange={(newValue) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              levelOfEffort: newValue,
            }))
          }
        />
      </Form.Item>
      <Form.Item label="Scope of Return">
        <Select
          style={{ width: '150px' }}
          value={isNotNull(optimizeData) ? optimizeData.scopeOfReturn : ''}
          options={optimizeOptions.scopeOfReturn}
          onChange={(newValue) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              scopeOfReturn: newValue,
            }))
          }
        />
      </Form.Item>
      <Form.Item label="Category">
        <Select
          style={{ width: '300px' }}
          value={isNotNull(optimizeData) ? optimizeData.category : ''}
          options={optimizeOptions.categories}
          onChange={(newValue) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              category: newValue,
            }))
          }
        />
      </Form.Item>
      <Form.Item label="Steps Required">
        <TextArea
          style={{ width: '100%' }}
          value={optimizeData.stepsRequired}
          onChange={(evt) =>
            setOptimizeData((prevState) => ({
              ...prevState,
              stepsRequired: evt.target.value,
            }))
          }
        />
      </Form.Item>
    </div>
  );
};
export default OptimizeForm;
